
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"20","viewBox":"0 0 25 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 0h19a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm5.28 9.59H3.59a.52.52 0 01-.52-.52V5.52A.52.52 0 013.59 5h4.69a.52.52 0 01.52.52v3.55c0 .288-.232.52-.52.52zM4.11 8.55H7.76V6.04H4.11V8.55zm4.1 7.2H3.52a.52.52 0 01-.52-.519V11.68a.52.52 0 01.52-.52h4.69a.52.52 0 01.52.52v3.551c0 .287-.233.52-.52.52zm-4.17-1.04H7.69V12.2H4.04v2.512zm10.397 1.04H9.746a.52.52 0 01-.52-.519V11.68a.52.52 0 01.52-.52h4.69a.52.52 0 01.52.52v3.551c0 .287-.232.52-.519.52zm-4.17-1.04h3.65V12.2h-3.65v2.512zm5.706 1.04h4.69c.287 0 .52-.232.52-.519V11.68a.52.52 0 00-.52-.52h-4.69a.52.52 0 00-.52.52v3.551c0 .287.233.52.52.52zm4.171-1.04h-3.651V12.2h3.651v2.512zM9.816 9.59h4.691c.287 0 .52-.232.52-.52V5.52a.52.52 0 00-.52-.52h-4.69a.52.52 0 00-.52.52v3.55c0 .288.233.52.52.52zm4.172-1.04h-3.652V6.04h3.652V8.55zm6.746 1.04h-4.691a.52.52 0 01-.52-.52V5.52a.52.52 0 01.52-.52h4.69a.52.52 0 01.52.52v3.55c0 .288-.232.52-.519.52zm-4.171-1.04h3.652V6.04h-3.652V8.55z"}})])
          )
        }
      }
    